export type BEButtonSizes = "DEFAULT" | "BIG" | "default" | "big";
type FEButtonSizes = "medium";
type BEButtonTypes = "PRIMARY" | "SECONDARY" | "TEXT" | "primary" | "secondary" | "text";
type FEButtonVariants = "contained" | "text";
type FEButtonColors = "primary" | "secondary";

export function getButtonSize(_beValue?: BEButtonSizes): { size: FEButtonSizes } {
  return { size: "medium" };
}

export function getButtonType(beValue?: BEButtonTypes): { color: FEButtonColors; variant: FEButtonVariants } {
  switch (beValue?.toLowerCase()) {
    case "primary":
      return { color: "primary", variant: "contained" };
    case "secondary":
      return { color: "secondary", variant: "contained" };
    case "text":
      return { color: "primary", variant: "text" };
    default:
      return { color: "primary", variant: "contained" };
  }
}
